import { Outlet } from "react-router-dom";
import { TableDataProvider } from "./context/TableDataContext";

function DatabaseLayout() {
    return (
        <TableDataProvider>
            <Outlet />
        </TableDataProvider>
    );
}

export default DatabaseLayout;
